import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, Field } from "@/components/common";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/format";

export default function Profile() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const mismatch = f.confirm && f.confirm !== f.new_password;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-xl">
      <PageHeader eyebrow={ROLE_LABEL[user.role]} title="My account" subtitle={`${user.name} · ${user.email}`} />
      <div className="panel p-6 space-y-4 fade-up">
        <Field label="Current password" required><Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="profile-current-password" /></Field>
        <Field label="New password" required hint="Minimum 8 characters"><Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="profile-new-password" /></Field>
        <Field label="Confirm new password" required error={mismatch ? "Passwords do not match" : undefined}><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="profile-confirm-password" /></Field>
        <Button onClick={save} disabled={busy || !f.current_password || f.new_password.length < 8 || mismatch || !f.confirm} className="bg-emerald-800 hover:bg-emerald-900" data-testid="profile-save-button">Update password</Button>
      </div>
    </div>
  );
}
